import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import uri from "../../../constants/uri";

const saveVotingFile = async (file, votingId) => {
	const formData = new FormData();
	formData.append("file", file);
	await client.post(`${uri}/attachment/${votingId}`, formData, {
		headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
	});
};

export default saveVotingFile;
